import classNames from 'classnames';
import './style.scss';

interface IProps {
  readonly value: string;
  readonly style?: React.CSSProperties;
  readonly className?: string;
}

export const Preview = (props: IProps) => {
  const className = classNames('preview vditor-reset', props?.className || '');
  return (
    <div
      style={props?.style || {}}
      className={className}
      dangerouslySetInnerHTML={{ __html: props.value }}
    ></div>
  );
};
